import { getApi } from 'common/modules/ReactShared';
import { ILessonsRequestParams, ILessonsResponse } from './types';

export async function getLessons(
  params?: ILessonsRequestParams
): Promise<ILessonsResponse> {
  const { data } = await getApi().get<ILessonsResponse>(`/profile/lessons/completed`, {
    params
  });

  return data;
}
